import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Navigation from './sections/Navigation';
import Footer from './sections/Footer';
import Home from './pages/Home';
import About from './pages/About';
import BusinessDevelopment from './pages/BusinessDevelopment';
import Partnering from './pages/Partnering';
import News from './pages/News';
import Contact from './pages/Contact';
import styles from './style/app.module.css';

function App() {
  return (
    <div className={styles.App}>
      <HashRouter>
        <Navigation />
        <div className={styles.content}>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/about" element={<About />}></Route>
            <Route path="/bd" element={<BusinessDevelopment />}></Route>
            <Route path="/partnering" element={<Partnering />}></Route>
            <Route path="/news" element={<News />}></Route>
            <Route path="/contact" element={<Contact />}></Route>
          </Routes>
        </div>
        <Footer />
      </HashRouter >
    </div >
  );
}

export default App;
